import { h, render } from "vue";
import NotifyContent from "@/components/base/NotifyContent.vue";

function _getNextZIndex() {
  // 获取页面中所有van-popup元素，返回最大值+10
  const allPopupElem = document.querySelectorAll(".van-popup");
  let maxZIndex = 2000; // 默认基础值
  allPopupElem.forEach((element) => {
    const zIndex = parseInt(window.getComputedStyle(element).zIndex);
    if (!isNaN(zIndex) && zIndex > maxZIndex) {
      maxZIndex = zIndex;
    }
  });
  return maxZIndex + 10;
}

function _createCustomNotify(message, type, duration = 2000) {
  // 创建临时DOM容器
  const container = document.createElement("div");
  document.body.appendChild(container);

  // 创建内容节点
  const contentNodes = h(NotifyContent, { message, type });

  // 创建Notify主节点
  const notifyVNode = h(
    "div",
    {
      class:
        "van-popup van-popup-slide-top-leave-active van-popup-slide-top-leave-to",
      style: {
        zIndex: _getNextZIndex(),
        top: 0,
        left: 0,
        width: "100%",
        background: "transparent",
        "transition-duration": "0.2s",
      },
    },
    contentNodes
  );

  // 渲染到 DOM
  render(notifyVNode, container);

  // 获取渲染后的元素
  const notifyEl = container.firstElementChild;

  // 添加显示动画
  setTimeout(() => {
    notifyEl.classList.remove(
      "van-popup-slide-top-leave-active",
      "van-popup-slide-top-leave-to"
    );
    notifyEl.classList.add(
      "van-popup-slide-top-enter-active",
      "van-popup-slide-top-enter-to"
    );
  });

  // 自动关闭
  setTimeout(() => {
    // 添加关闭动画
    notifyEl.classList.remove(
      "van-popup-slide-top-enter-active",
      "van-popup-slide-top-enter-to"
    );
    notifyEl.classList.add(
      "van-popup-slide-top-leave-active",
      "van-popup-slide-top-leave-to"
    );

    // 动画结束后移除元素
    setTimeout(() => {
      render(null, container);
      document.body.removeChild(container);
    }, 300);
  }, duration);
}

export class Notify {
  static success(message, duration = 2000) {
    _createCustomNotify(message, "success", duration);
  }
  static error(message, duration = 3000) {
    _createCustomNotify(message, "fail", duration);
  }
  static warn(message, duration = 3000) {
    _createCustomNotify(message, "warn", duration);
  }
}
